export default {
  AUTH: '/auth',
  HOME: '/home',

  LOGIN: '/auth/login',
  CHANGE_PASSWORD: '/auth/change-password',

  ACCOUNT: '/home/account',
  USER_LIST: '/home/users',

  DEVELOPER_LIST: '/home/developers',
  DEVELOPER_DETAIL: '/home/developers/:id',
  DEVELOPER_DETAIL_APPLICATONS: '/home/developers/:id/applications',
  DEVELOPER_DETAIL_APPLICATONS_REGISTER:
    '/home/developers/:id/applications/register',
  DEVELOPER_DETAIL_APPLICATONS_DETAIL:
    '/home/developers/:id/applications/:appId',
  DEVELOPER_REGISTER: '/home/developers/register',

  APPLICATION_LIST: '/home/applications',
  APPLICATION_DETAIL: '/home/applications/:appId',
  APPLICATION_REGISTER: '/home/applications/register',

  SSID_LIST: 'home/ssids',

  API_LIST: '/home/apis',
  API_REGISTER: '/home/apis/register',
  API_DETAIL: '/home/apis/:id',
};
